/**
 * @generated SignedSource<<1190bf2860328fe13b4763f9a8bfc89c>>
 * @relayHash 4ef1d37d96c6a8c5ed6ef879712e4a2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3bd6ef280f36b4d0a7f2705742612afdc0bf6300cd8a02cb618f09981fa319b7

import type { ConcreteRequest } from 'relay-runtime';
export type EndOfPageRecMenuItemEndOfPageRecHideQuery$variables = {
  exp: string;
  id: string;
  key: string;
  type: string;
};
export type EndOfPageRecMenuItemEndOfPageRecHideQuery$data = {
  readonly getRecommendedPages: {
    readonly recommendedPages: ReadonlyArray<{
      readonly content: {
        readonly id: string | null | undefined;
      } | null | undefined;
    }>;
    readonly status: {
      readonly isEnabled: boolean;
      readonly userCanToggle: boolean;
    };
  } | null | undefined;
  readonly getRecommendedPagesSpaceStatus: {
    readonly recommendedPagesEnabled: boolean;
  } | null | undefined;
};
export type EndOfPageRecMenuItemEndOfPageRecHideQuery = {
  response: EndOfPageRecMenuItemEndOfPageRecHideQuery$data;
  variables: EndOfPageRecMenuItemEndOfPageRecHideQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "exp"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "entityType",
        "variableName": "type"
      },
      {
        "kind": "Variable",
        "name": "experience",
        "variableName": "exp"
      }
    ],
    "concreteType": "RecommendedPages",
    "kind": "LinkedField",
    "name": "getRecommendedPages",
    "plural": false,
    "selections": [
      {
        "concreteType": "RecommendedPagesItem",
        "kind": "LinkedField",
        "name": "recommendedPages",
        "plural": true,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "RecommendedPagesStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "userCanToggle"
          },
          {
            "kind": "ScalarField",
            "name": "isEnabled"
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "key"
      }
    ],
    "concreteType": "RecommendedPagesSpaceStatus",
    "kind": "LinkedField",
    "name": "getRecommendedPagesSpaceStatus",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "recommendedPagesEnabled"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EndOfPageRecMenuItemEndOfPageRecHideQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "EndOfPageRecMenuItemEndOfPageRecHideQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "4ef1d37d96c6a8c5ed6ef879712e4a2d",
    "id": "3bd6ef280f36b4d0a7f2705742612afdc0bf6300cd8a02cb618f09981fa319b7",
    "metadata": {},
    "name": "EndOfPageRecMenuItemEndOfPageRecHideQuery",
    "operationKind": "query",
    "text": "query EndOfPageRecMenuItemEndOfPageRecHideQuery($type:String!,$id:ID!,$exp:String!,$key:ID!){getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id}},status{userCanToggle,isEnabled}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled}}"
  }
};
})();

(node as any).hash = "79772c88d8c3716d45c41ebed97e3fa0";

export default node;
